import React, { FunctionComponent } from "react";
import { RepairabilityIndexIcon } from "./RepairabilityIndexIcon";
import {ProductDocumentList} from "@/models/scope/productSheet/ProductDocumentList";
interface Props {
    score: string;
    documentId: ProductDocumentList<string> | null,
}
const indexColor = {
    red: "#D91627",
    orange: "#FE741B",
    yellow: "#FFC901",
    green: "#9ECC00",
    darkGreen: "#009443",
};
const getColor = (score: string) => {
    const parsedScore = parseFloat(score);
    if (parsedScore >= 8) {
        return indexColor.darkGreen;
    }
    if (parsedScore >= 6) {
        return indexColor.green;
    }
    if (parsedScore >= 4) {
        return indexColor.yellow;
    }
    if (parsedScore >= 2) {
        return indexColor.orange;
    }
    return indexColor.red;
};
export const RepairabilityIndex: FunctionComponent<Props> = ({ score,documentId }) => {
    if (!score) return null;
    return (
        <div style={{ marginBottom: "10px" }}>
            <RepairabilityIndexIcon documentId={documentId} score={parseFloat(score)} color={getColor(score)} />
        </div>
    );
};
